/**
 * Date helpers for pet dates stored as "YYYY-MM-DD".
 *
 * `new Date("2026-06-25")` is parsed as UTC midnight, so rendering it with
 * toLocaleDateString in a timezone behind UTC (e.g. Argentina, UTC-3) shows the
 * previous day. parseLocalDate builds the date in local time to avoid that shift.
 */
export function parseLocalDate(value) {
  if (!value) return null;
  const m = String(value).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return new Date(value); // full ISO datetime: leave as-is
  return new Date(+m[1], +m[2] - 1, +m[3]); // local date, no UTC shift
}

/**
 * Format a "YYYY-MM-DD" pet date for display in Spanish without timezone drift.
 * `opts` is passed through to toLocaleDateString (e.g. { month: 'long' }).
 */
export function formatPetDate(value, opts) {
  const d = parseLocalDate(value);
  return d ? d.toLocaleDateString('es', opts) : '—';
}
